(() => {
  document.querySelectorAll('[data-nfc-product]').forEach((section) => {
    const source = section.querySelector('[data-nfc-product-state]');
    if (!source) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    const form = section.querySelector('.product-form');
    const input = form?.querySelector('[data-variant-id]');
    const quantity = form?.querySelector('[name="quantity"]');
    const addButton = form?.querySelector('[data-add-button]');
    const image = section.querySelector('[data-nfc-main-image]');
    if (!form || !input || !quantity || !addButton) return;
    const variants = new Map(data.variants.map((variant) => [String(variant.id), variant]));
    const switchImage = (url, alt) => {
      if (!image || !url) return;
      image.src = url;
      image.alt = alt;
      section.querySelectorAll('[data-nfc-image]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.nfcImage === url)));
    };
    const select = (identifier, updateUrl) => {
      const variant = variants.get(String(identifier));
      if (!variant || form.getAttribute('aria-busy') === 'true') return;
      input.value = String(variant.id);
      const shopPay = form.querySelector('[data-nfc-shop-pay]');
      if (shopPay) { shopPay.disabled = !variant.available || addButton.dataset.planRequired === 'true'; shopPay.dataset.originalDisabled = String(shopPay.disabled); }
      section.querySelector('[data-product-price]').textContent = variant.price;
      section.querySelector('[data-nfc-selected-label]').textContent = variant.title;
      section.querySelector('[data-nfc-stock]').textContent = variant.available ? 'Available' : 'Sold out';
      section.querySelectorAll('[data-nfc-variant]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.nfcVariant === String(variant.id))));
      quantity.min = String(variant.min || 1);
      quantity.step = String(variant.step || 1);
      if (variant.max != null) quantity.max = String(variant.max); else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      const unavailable = !variant.available || addButton.dataset.planRequired === 'true';
      addButton.dataset.available = String(variant.available);
      addButton.dataset.originalDisabled = String(unavailable);
      addButton.disabled = unavailable || form.dataset.cartLocked === 'true';
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const feedback = form.querySelector('[data-form-status]');
      if (feedback) feedback.textContent = '';
      const quantityError = form.querySelector('[data-quantity-error]');
      if (quantityError) quantityError.textContent = '';
      quantity.removeAttribute('aria-invalid');
      switchImage(variant.image, variant.title);
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      }
    };
    section.addEventListener('click', (event) => {
      const variant = event.target.closest('[data-nfc-variant]');
      if (variant && form.dataset.cartLocked !== 'true') select(variant.dataset.nfcVariant, true);
      const thumbnail = event.target.closest('[data-nfc-image]');
      if (thumbnail) switchImage(thumbnail.dataset.nfcImage, thumbnail.dataset.nfcImageAlt);
    });
    window.addEventListener('popstate', () => select(new URL(window.location.href).searchParams.get('variant') || data.selectedId, false));
    select(new URL(window.location.href).searchParams.get('variant') || data.selectedId, false);
  });
})();
